import React from 'react';

import useCategoriesWithActions from '../Queries/useCategoriesWithActions';
import ProCategories, {RESOURCE_TITLE_CLASSES, ResourceBreadcrumbs} from './ProCategories';
import {categoryIcons} from '../Util/constants';

const ProParentCategories = () => {
  const {data: categories, error, refetch} = useCategoriesWithActions();
  const categoriesWithIcons = categories?.map((category) => ({
    ...category,
    icon: categoryIcons[category.name],
  }));

  return (
    <div data-testid="pro-parent-categories">
      <ResourceBreadcrumbs items={[{label: 'Home', to: '/dashboard'}, {label: 'Parents'}]} />
      <h1 className={`mb-6 ${RESOURCE_TITLE_CLASSES}`}>Parents</h1>
      <ProCategories
        categories={categoriesWithIcons}
        error={error}
        refetch={refetch}
        resourceLabel="parent resources"
      />
    </div>
  );
};

export default ProParentCategories;
